module.exports = __webpack_public_path__ + "img/hotAirBalloon.d2b7c709.png";